import { getUsers } from '@services/users/admin/get-users';

export const usersSDK = {
    admin: {
        get: getUsers,
    },
};
